export interface Limit {
    editType?: 'CREATE' | 'EDIT';
    title: string;
    desc: string;
    usageKey?: {
        pti: string;
        ptx: string;
    };
    oldAuthKey?: string;
}

const oldKeyMapping = {
    EDIT_GOAL: 'conversions',
    CREATE_GOAL: 'conversions',
    EDIT_CAMPAIGN: 'campaigns',
    CREATE_CAMPAIGN: 'campaigns',
    EDIT_USER_GROUP: 'userGroups',
    CREATE_USER_GROUP: 'userGroups',
    USE_AB_TEST: 'useCampaignAbTest',
    USE_CAMPAIN_SESSION: 'useCampaignUserGroupAndSession',
    USE_CAMPAIN_USERGROUPS: 'useCampaignUserGroupAndSession',
    USE_AI: 'useCampaignAI',
    USE_CODE_MODE: 'useCampaignCodeMode',
    QUICK_FILTER: 'useSegmentation'
};
const commonLimits = {
    collaborateUsers: {
        editType: 'CREATE',
        title: 'plan.collaborate_user_limit',
        desc: 'plan.collaborate_user_limit_desc',
        usageKey: {
            pti: 'ptiCollaborateUsers',
            ptx: 'ptxCollaborateUsers'
        }
    },
    pageGroups: {
        editType: 'CREATE'
    },
    conversions: {
        editType: 'CREATE',
        usageKey: {
            pti: 'ptiConversions',
            ptx: 'ptxConversions'
        },
        oldAuthKey: 'goals'
    },
    useCrossDomain: {
        editType: 'CREATE',
        title: 'plan.use_multiple_domain_limit',
        desc: 'plan.use_multiple_domain_limit_desc'
    }
} as const;

const ptxLimits = {
    EDIT_CAMPAIGN: {
        editType: 'EDIT',
        title: 'plan.campaign_limit',
        desc: 'plan.campaign_limit_desc'
    },
    campaigns: {
        editType: 'CREATE',
        title: 'plan.campaign_limit',
        desc: 'plan.campaign_limit_desc'
    },
    userGroups: {
        editType: 'CREATE',
        title: 'plan.usergroup_limit',
        desc: 'plan.usergroup_limit_desc'
    },
    usePopupForm: {
        editType: 'CREATE'
        // title: 'plan.use_popup_form_limit',
        // desc: 'plan.use_popup_form_limit_desc'
    },
    useCampaignAbTest: {
        editType: 'EDIT',
        title: 'plan.abtest_limit',
        desc: 'plan.abtest_limit_desc',
        oldAuthKey: 'useABTest'
    },
    // 与useCampaignAbTest权限一致，仅提示不同
    useCampaignRedirect: {
        editType: 'EDIT',
        title: 'plan.redirect_limit',
        desc: 'plan.redirect_limit_desc',
        oldAuthKey: 'useABTest'
    },
    useCampaignUserGroupAndSession: {
        editType: 'EDIT'
        // title: 'plan.use_campaign_usergroup_and_Session_lmit',
        // desc: 'plan.use_campaign_usergroup_and_Session_lmit_edit_desc'
    },
    useCampaignCodeMode: {
        editType: 'EDIT',
        title: 'plan.codemode_limit',
        desc: 'plan.codemode_limit_desc',
        oldAuthKey: 'useCodeMode'
    },
    useCampaignJSTrigger: {
        title: 'plan.use_campaign_js_trigger_limit',
        desc: 'plan.use_campaign_js_trigger_limit_desc'
    },
    useCampaignHeatmap: {
        title: 'plan.use_campaign_heatmap_limit',
        desc: 'plan.use_campaign_heatmap_limit_desc'
    },
    useCampaignAI: {
        title: 'plan.use_campaign_ai_limit',
        desc: 'plan.use_campaign_ai_limit_desc',
        oldAuthKey: 'useAI'
    }
} as const;

const ptiLimits = {
    heatmaps: {
        editType: 'CREATE'
        // title: 'plan.heatmaps_limit',
        // desc: 'plan.heatmaps_limit_desc'
    },
    historicalHeatmaps: {
        editType: 'CREATE'
        // title: 'plan.historical_heatmaps_limit',
        // desc: 'plan.historical_heatmaps_limit_desc'
    },
    useSegmentation: {
        editType: 'CREATE',
        title: 'plan.use_segmentation_limit',
        desc: 'plan.use_segmentation_limit_desc'
    },
    useHeatmapCompetitor: {
        editType: 'CREATE',
        oldAuthKey: 'psComparison'
        // title: 'plan.use_heatmap_competitor_limit',
        // desc: 'plan.use_heatmap_competitor_limit_desc'
    },
    useSharableHeatmap: {
        editType: 'CREATE'
        // title: 'plan.use_sharable_heatmap_limit',
        // desc: 'plan.use_sharable_heatmap_limit_desc'
    },
    useHeatmapAbTest: {
        editType: 'CREATE'
        // title: 'plan.use_heatmap_abtest_limit',
        // desc: 'plan.use_heatmap_abtest_limit_desc'
    }
} as const;

export default {
    oldKeyMapping,
    ptxLimits,
    ptiLimits,
    commonLimits
};
